import { createUseStyles } from 'react-jss';

export default createUseStyles({
  container: {
    padding: '52px 48px',
    '@media(max-width: 900px)': {
      padding: '26px 24px',
    }
  },

  title: {
    color: '#102131',
    fontFamily: '"Manrope", sans-serif',
    fontSize: '24px',
    fontWeight: 'bold',
  },

  form: {
    marginTop: '72px',
  },

  buttonFooter: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    flexDirection: 'row-reverse',
  },

  button: {
    width: '45%',
    '@media(max-width: 900px)': {
      width: '100%',
    }
  },

  message: {
    color: '#B2B9C0',
    fontSize: '16px',
    marginTop: '30px',
    marginBottom: '16px',
  },
});
